export default function validateImportData(data, role) {
  let errors = []
  if (role === 'Students') {
    data.forEach((record) => {
      if (!record.firstName) {
        errors.push(`Row ${record.row}: firstName is required.`)
      }
      if (!record.lastName) {
        errors.push(`Row ${record.row}: lastName is required.`)
      }
      if (!record.username && !record.email) {
        errors.push(`Row ${record.row}: Either email or username is required.`)
      }
      if (record.sendInvite !== 'yes' && record.sendInvite !== 'no') {
        errors.push(`Row ${record.row}: sendInvite must be either yes or no.`)
      }
      if (record.sendInvite === 'yes' && !record.email) {
        errors.push(`Row ${record.row}: If sendInvite is yes, email is required.`)
      }
      if (record.sendInvite === 'yes' && record.password) {
        errors.push(`Row ${record.row}: If sendInvite is yes, password must be left blank.`)
      }
      if (record.sendInvite === 'no' && !record.password) {
        errors.push(`Row ${record.row}: If sendInvite is no, password is required.`)
      }
    })
  } else if (role === 'Teachers') {
    data.forEach((record) => {
      if (!record.firstName) {
        errors.push(`Row ${record.row}: firstName is required.`)
      }
      if (!record.lastName) {
        errors.push(`Row ${record.row}: lastName is required.`)
      }
      if (!record.email) {
        errors.push(`Row ${record.row}: email is required.`)
      }
      if (record.sendInvite !== 'yes' && record.sendInvite !== 'no') {
        errors.push(`Row ${record.row}: sendInvite must be either yes or no.`)
      }
      if (record.sendInvite === 'yes' && record.password) {
        errors.push(`Row ${record.row}: If sendInvite is yes, password must be left blank.`)
      }
      if (record.sendInvite === 'no' && !record.password) {
        errors.push(`Row ${record.row}: If sendInvite is no, password is required.`)
      }
    })
  }
  return errors
}


// WEBPACK FOOTER //
// ./src/helpers/users/validateImportData.js